import { Component, Injector } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppComponentBase } from 'src/app/app-component-base';
import { AppConsts } from '../shared/AppConsts';
import { VersionCheckService } from '../shared/services/version.check.service';
import { AppComponent } from './app.component';
import { AuthenticationService } from './_services/authentication.service';
import {
    ConfiguracionUnidadResponse,
    ConfigurarHospitalServiceProxy,
    SessionLoginResponseController
} from '../shared/service-proxies/service-proxies';
import { finalize } from 'rxjs';
import { CitasNoOtorgadasService } from './_services/citasnootorgadas.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    providers: [MessageService]
})
export class AppTopBarComponent extends AppComponentBase {

    multiTenancy: boolean = AppConsts.multiTenancy;
    versionChanged: boolean;
    notificationsList = [];
    currentUser: SessionLoginResponseController;

    hospitalModel: ConfiguracionUnidadResponse;
    hayNuevasCitasNoOtorgadas = false;
    vibrarPorCitasNuevas = false;
    primeraVezAlertaCitasNoOtorgadas = true;
    intervalVibrar = null;

    isHost = false;

    constructor(public app: AppComponent,
        injector: Injector,
        private versionCheckService: VersionCheckService,
        private confirmationService: ConfirmationService,
        private authenticationService: AuthenticationService,
        private service: ConfigurarHospitalServiceProxy,
        private citasNoOtorgadasService: CitasNoOtorgadasService) {
        super(injector);

        this.versionCheckService.versionChanged.subscribe(x => {
            this.versionChanged = x;

            if (x) {
                this.confirmationService.confirm({
                    header: this.l('NewVersion'),
                    icon: 'pi pi-info',
                    message: this.l('NewAppVersionMessage'),
                    acceptLabel: this.l('UpdateNow'),
                    rejectLabel: this.l('Cancel'),
                    accept: () => {
                        this.updateAppVersion();
                    }
                });
            }
        });

        this.currentUser = this.app.currentUser;

        this.updateImageProfile();
    }

    ngOnInit() {
        const self = this;

        self.hospitalModel = new ConfiguracionUnidadResponse();

        if (!AppConsts.isHost) {
            self.getHospitalInfo();
        }

        this.isHost = AppConsts.isHost;

        if (!this.isHost) {
            // Se suscribe al servicio de búsqueda de pacientes
            self.citasNoOtorgadasService.citasNoOtorgadas.subscribe(m => {
                self.alertarCitasNoOtorgadas(m);
            });
        }
    }

    alertarCitasNoOtorgadas(hayNuevas: boolean): void {
        const self = this;

        if (hayNuevas) {

            self.hayNuevasCitasNoOtorgadas = true;
            self.notify.error(self.l('Procesos.SesionesHD.Citas.NoOtorgadas.PendienteRevisar'),
                self.l('Procesos.SesionesHD.Citas.NoOtorgadas.TituloNotificacion'));

            // Se ejecutará cada 30 segundos
            self.intervalVibrar = setInterval(function () {
                // La bandera hayCitasNoOtorgadas indica que no se ha abierto la ventana modal para inspeccionarlas
                // Entonces debe mostrarse la "vibración"
                if (self.hayNuevasCitasNoOtorgadas) {

                    self.vibrarPorCitasNuevas = true;

                    // Apagar la alerta a los 3 segundos
                    setTimeout(function () {
                        self.vibrarPorCitasNuevas = false;
                    }, 3000);

                }
            }, 30000);
        }
    }

    mostrarCitasNoOtorgadas(event): void {
        const self = this;

        self.citasNoOtorgadasService.mostrarCitasNoOtorgadas();
        self.hayNuevasCitasNoOtorgadas = false;
        self.vibrarPorCitasNuevas = false;

        if (self.intervalVibrar) {
            clearInterval(self.intervalVibrar);
            self.intervalVibrar = null;
        }

        event.preventDefault();
    }

    getHospitalInfo(): void {
        const self = this;

        self.service.getConfiguracionHospital()
            .pipe(finalize(() => {
            }))
            .subscribe(data => {
                if (data) {
                    self.hospitalModel = data;
                }
            });
    }

    updateImageProfile(): void {
        this.urlPictureProfile = this.getBaseServiceUrl() + '/api/User/GetPictureProfile?id=' +
            this.app.currentUser.userId + '&v' + (new Date().getTime());
    }

    updateAppVersion(): void {
        this.versionCheckService.updateVersion();
    }

    deleteNotifications(event): void {
        const self = this;

        self.notificationsList = [];
        self.app.topbarItemClick = true;

        event.preventDefault();
    }
}
